import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { loginRio } from './login/loginRio';
import { Provider } from 'react-redux';
import { createStore } from './state/store';
import { ErrorBoundary } from './ErrorBoundary';
import { App } from './App';
import { handleExternalLogin } from './login/external/externalLogin';

// Import of ReactToastify.css is needed to avoid remote loading of css at
// runtime which would fail due to content security policy on the environments
import 'react-toastify/dist/ReactToastify.css';
import './uikit-overrides.css';
import { User as SimplePayUser } from './login/loginSlice';
import { appConfiguration } from './configuration/appConfiguration';

const container = document.getElementById('root')!;
const root = createRoot(container);

const createApp = (user: SimplePayUser) => {
  const app = (
    <ErrorBoundary>
      <Provider store={createStore(user)}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  );

  return appConfiguration.strictMode ? (
    <React.StrictMode>{app}</React.StrictMode>
  ) : (
    app
  );
};

handleExternalLogin()
  .then(loginRio)
  .then((user) => {
    if (!user) {
      return <></>;
    }
    return root.render(createApp(user));
  });
